import Button, { type ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { RADIUS_COIN, RADIUS_ITEM } from 'styles/tokens';

const PrimaryBtn = styled(Button)<ButtonProps>(() => ({
  transition: 'all 0.15s ease-in-out',
  borderRadius: RADIUS_COIN,
  height: '43px',
  minWidth: '125px',
  paddingRight: '12px',
}));

const ContactButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.yellow.main,
  color: theme.palette.primaryDark.main,
  padding: theme.spacing(1, 4),
  fontWeight: 600,
  borderRadius: RADIUS_ITEM,
  '&:hover': {
    backgroundColor: theme.palette.yellow.main,
    opacity: 0.8,
    color: theme.palette.primaryDark.main,
  },
}));

export { ContactButton, PrimaryBtn };
